// eslint-disable-next-line vue/max-len
export const PRICING_UID_REGEX = /^(?<departure>[A-Z]{3})(?<date>\d{2})(?<month>\d{2})(?<arrival>[A-Z]{3})T(?<pieces>\d+(?:[.,]\d+)?)K(?<weight>\d+(?:[.,]\d+)?)MC(?<volume>\d+(?:[.,]\d+)?)(?<shc>(?:[A-Z0-9]{3})+)?$/;
